export enum SessionStorageEnum {
  CartStatus = "PJ_cartStatus",
  CartTag = "PJ_cartTag",
  CartProductVersion = "PJ_cartProductVersion",
  CartActiveFeatures = "PJ_cartActiveFeatures",
  CartRegistrationTag = "PJ_cartRegistrationTag",
  Clerk = "PJ_clerk",
  ClerkJwt = "PJ_ClerkJwt",
  DataDogRumSessionType = "PJ_dataDogRumSessionType",
  DeviceTag = "PJ_deviceTag",
  EcommerceSaleFinished = "PJ_ecommerceSaleFinished",
  Merchant = "PJ_merchant",
  MerchantCountry = "PJ_MerchantCountry",
  MerchantJwt = "PJ_MerchantJwt",
  MktGid = "PJ_MktGid",
  OriginationChannel = "PJ_originationChannel",
  PersonRegistrationTag = "PJ_personRegistrationTag",
  RedirectUrl = "PJ_RedirectUrl",
  UniqueRequestList = "uniqueRequestList",
  UserTag = "PJ_userTag",
}
